import { Tooltip } from '@mui/material';
import React from 'react';
import { Style } from '../../models/Style';
import Preview from '@mui/icons-material/Preview';
import Image from 'next/image';

interface Props {
  style: Style;
  selectedStyles: Partial<Style>[];
  handleStyleSelection: (style: Style) => void;
  openPreview: (style: Style) => void;
}

export default function StyleCard({
  style,
  selectedStyles,
  handleStyleSelection,
  openPreview,
}: Props) {
  const selected = selectedStyles.some((selectedStyle) => selectedStyle.id === style.id);
  const hasSeveralImages = style.previewUrls.length > 1;

  const onOpenPreview = (e) => {
    e.stopPropagation();
    if (openPreview) {
      openPreview(style);
    }
  };
  return (
    <div
      key={style.id}
      onClick={() => (style.default ? '' : handleStyleSelection(style))}
      className={`flex flex-col m-1 transition-shadow relative text-center w-32 md:w-40 lg:w-52 ${
        style.default ? '' : ' cursor-pointer'
      }`}
    >
      <div className='flex items-center relative bg-white rounded-2lg'>
        <Image
          src={style.previewUrls[0] ?? '/default_style_image.webp'}
          alt={style.name}
          loading='eager'
          width={250}
          height={250}
          sizes='(max-width: 768px) 250px'
          className={`rounded-2lg hover:shadow-lg max-w-full object-cover h-32 md:h-40 lg:h-52 ${
            selected
              ? 'border-solid border-green border-2'
              : style.default
              ? 'border-2 border-purple'
              : ' border-2 border-transparent opacity-70'
          }`}
        />
        {hasSeveralImages && (
          <Tooltip title='Ver ejemplos'>
            <button className='top-2 right-2 absolute fill-white' onClick={onOpenPreview}>
              <Preview fontSize='medium' className='fill-white hover:fill-accent' />
            </button>
          </Tooltip>
        )}
        <input
          onChange={() => (style.default ? '' : handleStyleSelection(style))}
          checked={style.default ? true : selected}
          disabled={style.default}
          id='green-checkbox'
          type='checkbox'
          value=''
          className={`w-6 h-6 md:w-8 md:h-8 rounded-2xl bottom-2 right-2 absolute text-green-600 bg-gray-100  checked:bg-green hover:bg-green checked:hover:bg-green focus:bg-green checked:focus:bg-green dark:ring-offset-gray-800 focus:bg-green dark:bg-gray-700 dark:border-gray-600' 
              ${
                style.default
                  ? 'checked:bg-purple hover:bg-purple checked:bg-purple focus:bg-purple checked:focus:bg-purple dark:ring-offset-gray-800 checked:hover:bg-purple focus:bg-purple dark:bg-gray-700 dark:border-gray-600'
                  : ''
              }`}
        ></input>
      </div>
      <div
        className={`dark:text-white text-xs md:text-sm truncate ${
          selected ? 'green font-semibold' : ''
        }`}
      >
        {style.name}
      </div>
    </div>
  );
}
